module.exports = __webpack_public_path__ + "img/portrait_1920.a74687f2.jpg";